export default __webpack_public_path__ + "locales/sr-Latn-RS/PeopleTranslations.json?hash=1fd101edf87e9d7fb4ac4e448047f86e";